export default __webpack_public_path__ + "static/media/FX1.e540a160.mp3";